module.exports = __webpack_public_path__ + "img/zizhi23.d352cc40.png";